module.exports = __webpack_public_path__ + "img/yuanhuizhen2.1ccd9573.png";